// react
import { useState } from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

// material ui
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MobileStepper,
  Typography,
} from '@mui/material';

// relative
import image1 from './guide-stepper/pictures/image1.png';
import image2 from './guide-stepper/pictures/image2.png';
import image3 from './guide-stepper/pictures/image3.png';
import image4 from './guide-stepper/pictures/image4.png';
import image5 from './guide-stepper/pictures/image5.png';

function DatahubGuideDialog({ open, onClose }) {
  const { t } = useTranslation('datahub-integration-guide-stepper');
  const [activeStep, setActiveStep] = useState(0);

  const guideSteps = [
    {
      image: image1,
      label: t('guide.step1.title'),
      description: t('guide.step1.description'),
    },
    {
      image: image2,
      label: t('guide.step2.title'),
      description: t('guide.step2.description'),
    },
    {
      image: image3,
      label: t('guide.step3.title'),
      description: t('guide.step3.description'),
    },
    {
      image: image4,
      label: t('guide.step4.title'),
      description: t('guide.step4.description'),
    },
    {
      image: image5,
      label: t('guide.step5.title'),
      description: t('guide.step5.description'),
    },
  ];

  const maxSteps = guideSteps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleClose = () => {
    setActiveStep(0);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>{t('guide.title')}</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ maxWidth: 800, flexGrow: 1, mx: 'auto' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: 500,
              width: '100%',
            }}
          >
            <Box
              component="img"
              sx={{
                maxWidth: '100%',
                maxHeight: '100%',
                height: 'auto',
                width: 'auto',
                borderRadius: 2,
                boxShadow: 3,
                border: '1px solid',
                borderColor: 'divider',
              }}
              src={guideSteps[activeStep].image}
              alt={guideSteps[activeStep].label}
            />
          </Box>
          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              {guideSteps[activeStep].label}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {guideSteps[activeStep].description}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <MobileStepper
          variant="dots"
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          sx={{ flexGrow: 1, maxWidth: 400 }}
          nextButton={
            <Button
              size="small"
              onClick={handleNext}
              disabled={activeStep === maxSteps - 1}
            >
              {t('guide.next')}
              <KeyboardArrowRight />
            </Button>
          }
          backButton={
            <Button
              size="small"
              onClick={handleBack}
              disabled={activeStep === 0}
            >
              <KeyboardArrowLeft />
              {t('guide.back')}
            </Button>
          }
        />
      </DialogActions>
      <DialogActions>
        <Button onClick={handleClose}>{t('guide.close')}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default DatahubGuideDialog;
